import { formatDate } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { NgxPrintModule } from 'ngx-print'; // or 'ngx-print-latest' depending on your package
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-issue-seller-print-order-statement-component',
  templateUrl: './issue-seller-print-order-statement-component.component.html',
  styleUrl: './issue-seller-print-order-statement-component.component.scss'
})
export class IssueSellerPrintOrderStatementComponentComponent implements OnInit {
  printorderData;
  today = new Date();
  startDate = '';
  endDate = '';
  issueName = '';
  issuedate = '';

  tempdata = [
    { no: 1, name: 'अभिकर्ता', prati: 0, shera: '' },
    { no: 2, name: 'वर्गणी', prati: 0, shera: '' },
    { no: 3, name: 'स. भेट', prati: 0, shera: '' },
    { no: 4, name: 'प्रचार स. भेट', prati: 0, shera: '' },
    { no: 5, name: 'जाहिरात स. भेट', prati: 0, shera: '' },
    { no: 6, name: 'जादा अंक', prati: 0, shera: '' },
    { no: 7, name: 'जादा विक्री', prati: 0, shera: '' },
    { no: 8, name: 'कार्यालय ', prati: 0, shera: '' },
    { no: 9, name: 'स सप्रेम भेट', prati: 0, shera: '' },
  ];

  testdata = [
    { name: '५० जी एस एम मफलीथो पेपर ' },
    { name: '६५ जी एस एम एल डब्लु सी पेपर ' },
    { name: '९० जी एस एम आर्ट  पेपर' },
  ];

  totalprati = 0;
  totalpsankhya = 0;

  tempData = [
    { prushta_kr: '01-02 व 51-52', prushta_sankhya: '4', prakar: 'रंगीत', pane_denar: 'गुरुवार' },
    { prushta_kr: '03-12 व 41-50', prushta_sankhya: '20', prakar: 'कृष्णधवळ', pane_denar: 'शुक्रवार' },
    { prushta_kr: '13-20 व 33-40', prushta_sankhya: '16', prakar: 'रंगीत', pane_denar: 'गुरुवार' },
    { prushta_kr: '21-26 व 27-32', prushta_sankhya: '12', prakar: 'कृष्णधवळ', pane_denar: 'बुधवार' },
    { prushta_kr: '', prushta_sankhya: '', prakar: '', pane_denar: '' },
  ];

  issue_type: any;

  // ===== कालजयी श्रीगुरुजी अंक नोंदणी - Auto-fetched from Office Rep data (READ-ONLY) =====
  printOrderSummary: any[] = [];

  totalJama = 0;
  totalBakiAnki = 0;
  totalEkun = 0;


  // Second table (संपादकीय / जाहिरात / कार्यालय) - MANUAL entry
  additionalEntries = [
    { name: 'संपादकीय', label: 'लॅमिनेशन', value: 0 },
    { name: 'जाहिरात', label: 'लॅमिनेशन', value: 0 },
    { name: 'कार्यालय', label: '', value: 0 },
  ];

  grandTotalMarathi = 0;

  // Loading / error flags so the template can show useful feedback instead of a blank table
  isLoadingPrintOrder = false;
  isLoadingSummary = false;
  printOrderError = '';
  summaryError = '';
  // ===== End summary table properties =====

  weeksCount: any;
  year: any;
  sdate: any;
  edate: any;

  constructor(
    private dialogref: MatDialogRef<IssueSellerPrintOrderStatementComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    // Guard: the dialog depends entirely on `issuedate` being passed in via MAT_DIALOG_DATA.
    // If the parent forgets to pass it (as in the printOrder() snippet you shared, where
    // `issuetype` is commented out), fail loudly instead of silently doing nothing.
    if (!this.data || !this.data['issuedate']) {
      console.error(
        'IssueSellerPrintOrderStatementComponentComponent: missing "issuedate" in dialog data.'
      );
      return;
    }
    this.issueName = this.data['issueName'];   // matches parent's key
    this.issuedate = this.data['issuedate'];

    this.endDate = this.data['issuedate'];
    let weekfirstday =
      new Date(this.data['issuedate']).getDate() -
      new Date(this.data['issuedate']).getDay();
    this.startDate = formatDate(
      new Date(this.data['issuedate']).setDate(weekfirstday - 6),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    this.getweekcount();
    this.getPrintOrderData();
    this.totalPrati();
    this.getOffRepSummaryData(); // auto-fetch जमा/येणे/एकूण per representative
  }

  getweekcount() {
    const issuedate = new Date(this.data['issuedate']);
    this.issue_type = this.data.issuetype;
    const month = issuedate.getMonth() + 1;
    const year = this.getYearFromDate(issuedate);

    if (month >= 1 && month <= 3) {
      this.sdate = new Date(year - 1, 3, 1);
      this.edate = new Date(year, 2, 31);
    } else {
      this.sdate = new Date(year, 3, 1);
      this.edate = new Date(year + 1, 2, 31);
    }
    this.weeksCount = this.calculateWeeks(this.sdate, this.edate);
  }

  calculateWeeks(startDate: Date, endDate: Date): number {
    let weekCount = 0;
    let currentDate = new Date(startDate);

    while (currentDate.getDay() !== 0) {
      currentDate.setDate(currentDate.getDate() + 1);
    }

    while (currentDate <= endDate) {
      if (new Date(this.data['issuedate']) >= currentDate) {
        weekCount++;
      }
      currentDate.setDate(currentDate.getDate() + 7);
    }

    return weekCount;
  }

  getYearFromDate(date: Date): number {
    return date.getFullYear();
  }

  getPrintOrderData() {
    this.isLoadingPrintOrder = true;
    this.printOrderError = '';
    // NOTE: service signature is (issueName, issueDate) - matches this call order
    this.service.getissuesPrintOrderData(this.issueName, this.issuedate).subscribe({
      next: (res) => {
        this.tempdata.map((a) => {
          if (a.name === 'वर्गणी') {
            a.prati = parseInt(res['vargani']) || 0;
          } else if (a.name === 'स. भेट') {
            a.prati = parseInt(res['s_bhet']) || 0;
          }
        });
        this.totalPrati();
        this.isLoadingPrintOrder = false;
      },
      error: (err) => {
        console.error('getPrintOrderData failed:', err);
        this.printOrderError = 'Failed to load print order data.';
        this.isLoadingPrintOrder = false;
      },
    });
  }

  exportexcel(fileName): void {
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  addTempData(event, index, key) {
    this.tempData[index][key] = event.target.value;
    this.calculateTotal();
  }

  calculateTotal() {
    this.totalpsankhya = 0;
    for (let index = 0; index < Object.keys(this.tempData).length; index++) {
      this.totalpsankhya +=
        this.tempData[index]['prushta_sankhya'] == ''
          ? 0
          : parseInt(this.tempData[index]['prushta_sankhya']);
    }
  }

  addtempdata(event, index, name) {
    this.tempdata[index][name] =
      name === 'name' ? event.target.value : parseInt(event.target.value);
    this.totalPrati();
  }

  totalPrati() {
    this.totalprati = 0;
    for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
      this.totalprati += this.tempdata[index]['prati'];
    }
  }

  closeDialog() {
    if (
      window.confirm(
        'Are you sure want to close, Please save data before close'
      )
    ) {
      this.dialogref.close();
    }
  }

  // ===== Summary table methods =====
  //
  // IMPORTANT: `getissuesPrintOrderData()` must return an object shaped like:
  //   {
  //     vargani: number,
  //     s_bhet: number,
  //     officeWise: [
  //       { offRep: 'दयानंद', jama: 529, bakiAnki: 2621, ekun: 3150 },
  //       ...
  //     ],
  //     grandTotal: { jama: 1234, bakiAnki: 5678, ekun: 6912 }
  //   }
  //
  // If your backend endpoint does NOT return `officeWise` / `grandTotal`, you need a
  // dedicated service method (e.g. `getOffRepPrintOrderSummary(issuedate)`) that does.
  // Using the wrong endpoint is the most common reason this table renders empty with
  // no visible error: `res?.officeWise` silently falls back to `[]`.

  getOffRepSummaryData() {
    this.isLoadingSummary = true;
    this.summaryError = '';

    // NOTE: service signature is (issueName, issueDate) - matches this call order
    this.service.getissuesPrintOrderData(this.issueName, this.issuedate).subscribe({
      next: (res: any) => {

        console.log("Full Response :", res);

        let data: any[] = [];

        if (Array.isArray(res)) {
          data = res;
        } else if (Array.isArray(res.officeWise)) {
          data = res.officeWise;
        } else if (Array.isArray(res.data)) {
          data = res.data;
        } else if (Array.isArray(res.result)) {
          data = res.result;
        }

        this.printOrderSummary = data.map((item: any, index: number) => ({
          no: index + 1,
          name: item.offRep || item.off_rep || '',
          jama: Number(item.jama) || 0,
          bakiAnki: Number(item.bakiAnki || item.baki_anki) || 0,
          prati: Number(item.prati) || 0,
          ekun: Number(item.ekun) || 0
        }));

        this.calculateSummaryTotals();
        this.isLoadingSummary = false;
      },
      error: (err) => {
        console.error(err);
        this.summaryError = 'Unable to load summary';
        this.isLoadingSummary = false;
      }
    });
  }

  // Manual entry - only for संपादकीय / जाहिरात / कार्यालय
  updateAdditionalEntry(event, index) {
    this.additionalEntries[index].value = parseFloat(event.target.value) || 0;
    this.calculateGrandTotal();
  }

  calculateSummaryTotals() {
    this.totalJama = 0;
    this.totalBakiAnki = 0;
    this.totalEkun = 0;
    this.totalprati=0;
    
    this.printOrderSummary.forEach((item) => {
      this.totalJama += item.jama || 0;
      this.totalBakiAnki += item.bakiAnki || 0;
      this.totalEkun += item.ekun || 0;
      this.totalprati+=item.prati||0;
    });
    this.calculateGrandTotal();
  }

  calculateGrandTotal() {
    const additionalTotal = this.additionalEntries.reduce(
      (sum, e) => sum + (e.value || 0),
      0
    );
    this.grandTotalMarathi = this.totalEkun + additionalTotal;
  }
  // ===== End summary table methods =====

  // save() {
  //   let data = {
  //     order_date: formatDate(this.today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530'),
  //     issue_date_from: this.startDate
  //       ? formatDate(this.startDate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
  //       : null,
  //     issue_date_to: this.endDate
  //       ? formatDate(this.endDate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
  //       : null,
  //     total_prati: this.totalprati,
  //     total_prustha: this.totalpsankhya,
  //   };
  //
  //   let prusthaData = [];
  //   this.tempData.map((a) => {
  //     if (
  //       a['prushta_kr'] != '' ||
  //       a['prushta_sankhya'] != '' ||
  //       a['prakar'] != '' ||
  //       a['pane_denar'] != ''
  //     ) {
  //       prusthaData.push(a);
  //     }
  //   });
  //
  //   this.service.insertissuePrintOrderData(data).subscribe((res) => {
  //     if (res['success']) {
  //       this.service
  //         .insertissuesellerPrintOrderPrustha(res['id'], prusthaData)
  //         .subscribe();
  //
  //       this.service
  //         .insertissuesellerPrintOrderTypes(res['id'], this.tempdata)
  //         .subscribe();
  //
  //       // Persist manually-entered संपादकीय / जाहिरात / कार्यालय values
  //       this.service
  //         .insertissuePrintOrderAdditionalEntries(res['id'], this.additionalEntries)
  //         .subscribe(() => {
  //           alert('Print order saved successfully');
  //           this.dialogref.close();
  //         });
  //     } else {
  //       alert(res['msg']);
  //     }
  //   });
  // }

  addNewtempdata() {
    this.tempdata.push({
      no: this.tempdata.length + 1,
      name: '',
      prati: 0,
      shera: '',
    });
  }
}